import type { AppLocale } from "@/i18n/constants";

/** Copy for the illustrative interfaces on the service pages (not client data). */
const MOCKUPS = {
  es: {
    profile: {
      handle: "tu.negocio",
      bookLabel: "Reservar cita",
      highlights: ["Servicios", "Precios", "Opiniones", "Reservas"],
      tiles: ["Antes y después", "Tu equipo", "Reservá online", "3 tips", "Promo del mes", "Opiniones"],
      message: "¡Hola! ¿Tenés hueco el sábado?",
    },
    browser: {
      domain: "tunegocio.es",
      headline: "Tu centro, a un clic de reservar",
      bookTitle: "Elegí día y hora",
      days: ["Lun", "Mar", "Mié", "Jue", "Vie"],
      slots: ["09:30", "10:30", "11:00", "12:30", "16:00", "17:30"],
      confirm: "Reserva confirmada · Jue 16:00",
      reviews: "Reseñas de Google",
    },
    video: {
      title: "Tu asesoría personalizada",
      note: "Enlace privado de YouTube",
      chapters: ["Tu perfil", "Tu cliente ideal", "Tu contenido"],
    },
  },
  en: {
    profile: {
      handle: "your.business",
      bookLabel: "Book now",
      highlights: ["Services", "Prices", "Reviews", "Bookings"],
      tiles: ["Before & after", "Your team", "Book online", "3 tips", "Monthly offer", "Reviews"],
      message: "Hi! Any slots on Saturday?",
    },
    browser: {
      domain: "yourbusiness.com",
      headline: "Your studio, one click from a booking",
      bookTitle: "Choose a day and time",
      days: ["Mon", "Tue", "Wed", "Thu", "Fri"],
      slots: ["09:30", "10:30", "11:00", "12:30", "16:00", "17:30"],
      confirm: "Booking confirmed · Thu 16:00",
      reviews: "Google reviews",
    },
    video: {
      title: "Your personalised advisory",
      note: "Private YouTube link",
      chapters: ["Your profile", "Your ideal client", "Your content"],
    },
  },
} as const;

export function getMockups(locale: AppLocale) {
  return MOCKUPS[locale];
}
